
    import * as React from 'react';

    const Calendar24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M6.44434 3H7.55545V4.72222H12V3H13.1111V4.72222H17.5556V3H18.6667V4.72222H22H22.5V5.22222V20.7778V21.2778H22H2H1.5V20.7778V5.22222V4.72222H2H6.44434V3ZM13.1111 5.72222H17.5556V7.44444H18.6667V5.72222H21.5V8.55556H2.5V5.72222H6.44434V7.44444H7.55545V5.72222H12V7.44444H13.1111V5.72222ZM2.5 9.66667V20.2778H21.5V9.66667H2.5ZM6.44434 11.8889H10.8888V13H6.44434V11.8889ZM10.8889 16.3333H6.44444V17.4444H10.8889V16.3333ZM13.1111 11.8889H17.5556V13H13.1111V11.8889ZM17.5556 16.3333H13.1111V17.4444H17.5556V16.3333Z" /></svg>
        </div>
      );
    };

    Calendar24.displayName = 'Calendar24';

    export default Calendar24;
  